/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';
import modaal from 'modaal';

class Modal {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		$('.js-inline-modal').modaal();

		$('.js-internal-video').modaal({
			type: 'inline',
			custom_class: 'modaal-video',
			width: 930
		});

		$('.js-video').modaal({
			content_source: '.video-hero-modaal',
			overlay_opacity: 0.6,
			custom_class: 'video-hero-modal',
			width: 930
		});

		$('.js-story-video').each((index, ele) => {
			$(ele).modaal({
					content_source: $(ele).data('content-source'),
					overlay_opacity: 0.6,
					overlay_close: true,
					custom_class: 'video-hero-modal video-story-modal',
					width: 930
			});
		});

		$('.image-modal').modaal({
			type: 'image',
			width: 930
		});
		
		// Close when clicking Modaal overlay
		$(document).on('click', (e) => {
			if ($(e.target).hasClass('modaal-outer-wrapper')) {
				$('.image-modal, .js-video, .js-inline-modal').modaal('close');
			}
		});
    }
}

export default Modal;

$(() => {
	const modal = new Modal();
	modal.init();
});
